import { createSelector } from 'reselect'
import { State } from '../../reducers/reducerType'
import { WebcastInterface } from '@bt-react/store'
import get from 'lodash/get'

const getWebcastData = (state: State): WebcastInterface['data'] | null => {

  if (!state.config.channelId || !state.config.webcastId) return null

  const webcast = get(state.webcast.collection, `${state.config.channelId}${state.config.webcastId}`, null)

  return webcast ? webcast.data : null

}

export default createSelector<State, any, WebcastInterface['data'] | null>(
  [getWebcastData],
  (webcastData) => webcastData
)
